'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Tooltip = require('./Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  {
    "type": "tooltips",
    "tooltips": [
      {
        "type": "match"
      },
      {
        "type": "hot_job"
      }
    ]
  }

  This displays tooltips on the job description sidebar.

  `tooltips` is an array of tooltips to display. The type
  will be interpreted via the React component.
*/

function Tooltips(_ref) {
  var moduleClass = _ref.moduleClass,
      tooltips = _ref.tooltips;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-tooltips ' + moduleClass
    },
    _react2.default.createElement(
      'div',
      {
        className: 'tooltips-wrapper'
      },
      tooltips.map(function (tooltip, key) {
        return _react2.default.createElement(_Tooltip2.default, {
          key: key,
          tooltip: tooltip
        });
      })
    )
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps)(Tooltips);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Tooltips/Tooltips.jsx
// module id = 1268
// module chunks = 0